<template>
  <span class="showcase-pill" :class="`showcase-pill--${tone}`">
    <slot />
  </span>
</template>

<script>
  export default {
    name: 'ShowcasePill',
    props: {
      tone: {
        type: String,
        default: 'grey',
        validator: (value) => ['grey', 'blue', 'green', 'purple', 'yellow'].includes(value),
      },
    },
  };
</script>

<style scoped lang="scss">
  .showcase-pill {
    display: inline-block;
    padding: 0 6px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0.3px;
    white-space: nowrap;

    &--grey {
      background-color: #e9eaee;
      color: var(--showcase-text);
    }
    &--blue {
      background-color: var(--showcase-blue-bg);
      color: var(--showcase-primary);
    }
    &--green {
      background-color: var(--showcase-green-bg);
      color: var(--showcase-green);
    }
    &--purple {
      background-color: var(--showcase-purple-bg);
      color: #6a3dc8;
    }
    &--yellow {
      background-color: #fff2c2;
      color: #8a6500;
    }
  }
</style>
